import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {pushRoute} from '../../routes';
import {getUser} from './store/selectors';
import {getElection} from '../election/store/selectors';

const Welcome: React.FC = () => {
  const user = useSelector(getUser);
  const election = useSelector(getElection);
  const dispatch = useDispatch();

  if (
    election &&
    election.configs.enable_early_access === false &&
    election.status === 'pendent'
  ) {
    dispatch(pushRoute('unavailable'));

    return <React.Fragment />;
  }

  if (user) {
    dispatch(pushRoute('home'));
  } else {
    dispatch(pushRoute('auth'));
  }

  return <React.Fragment />;
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/features/auth/Welcome.tsx